import React from 'react'
import { Button, ButtonProps, CircularProgress, Box } from '@mui/material'

interface ActionButtonProps extends Omit<ButtonProps, 'loading'> {
  loading?: boolean
  loadingText?: string
  icon?: React.ReactNode
}

export function ActionButton({
  loading = false,
  loadingText,
  icon,
  children,
  disabled,
  ...props
}: ActionButtonProps) {
  return (
    <Button
      {...props}
      disabled={disabled || loading}
      startIcon={loading ? undefined : icon}
    >
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={16} />
          {loadingText || children}
        </Box>
      ) : (
        children
      )}
    </Button>
  )
}
